import { RouteRecordRaw } from "vue-router";
import { LAYOUT } from "../constants";

export default {
  path: "/index",
  redirect: "/index",
  name: "Home",
  component: LAYOUT,
  meta: {
    ignoreAuth: true,
    order: 1,
    title: "主页",
  },
  children: [
    {
      path: "",
      name: "HomePage",
      component: () => import("../../views/home/HomePage.vue"),
      meta: {
        title: "主页",
        ignoreAuth: true,
        icon: "ic:round-home",
      },
    },
  ],
} as RouteRecordRaw;
